import { useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import uploadImg from "../../../images/upload-img.png";
import "./style.scss";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import BaseService from "../../../services/BaseService";
import Loader from "../../common/Loader";
import { Translate } from "../../Enums/Tranlate";
import BannerService from "../../../services/BannerService";
import { AvField, AvForm } from "availity-reactstrap-validation";

const Banners = () => {
	const [shouldUpdate, setShouldUpdate] = useState(true);
	const [loading, setLoading] = useState(false);
	const [submitLoading, setSumbitLoading] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const bannerService = new BannerService();

	const [formData, setFormData] = useState([
		{
			src: "",
			loading: false,
			title_en: "",
			title_ar: "",
			description_en: "",
			description_ar: "",
		},
	]);

	useEffect(() => {
		bannerService?.getList()?.then((res) => {
			if (res && res?.status === 200) {
				if (res.data?.data?.length === 0) {
					return;
				}
				let data = res.data?.data?.map((item) => {
					return {
						id: item?.id,
						src: item?.image,
						title_en: item?.title_en,
						title_ar: item?.title_ar,
						description_en: item?.description_en,
						description_ar: item?.description_ar,
						loading: false,
					};
				});

				setFormData([...data]);
			}
			setLoading(false);
		});
	}, [shouldUpdate]);

	console.log(formData);
	const fileHandler = (e, index) => {
		if (e?.target.files?.length === 0) {
			return;
		}

		setFormData((prev) =>
			prev.map((item, ind) =>
				ind === index ? { ...item, loading: true } : item
			)
		);
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		new BaseService().postUpload(filesData[0]).then((res) => {
			if (res && res?.data?.status) {
				setFormData((prev) =>
					prev.map((item, ind) =>
						ind === index
							? { ...item, src: res.data.url, loading: false }
							: item
					)
				);
			} else {
				setFormData((prev) =>
					prev.map((item, ind) =>
						ind === index ? { ...item, loading: false } : item
					)
				);
			}
		});
	};

	const onSubmit = () => {
		let data = {
			banners: formData
				?.filter((res) => !!res.src)
				?.map((item) => {
					let res = {
						image: item?.src,
						description_en: item?.description_en,
						description_ar: item?.description_ar,
						title_en: item?.title_en,
						title_ar: item?.title_ar,
					};
					return res;
				}),
		};
		if (data.banners?.length === 0) {
			toast.error("Add Image");
			return;
		}

		setSumbitLoading(true);
		bannerService
			.create(data)
			?.then((res) => {
				if (res && res?.status === 201) {
					toast.success("Banners Added Successfully");
				}
				setSumbitLoading(false);
			})
			.catch(() => setSumbitLoading(false));
	};

	const removeBanner = (id) => {
		bannerService.remove(id).then((res) => {
			if (res?.status) {
				toast.success("Banner Remove Successfully.");
				setShouldUpdate((prev) => !prev);
			}
		});
	};

	if (loading) {
		return (
			<Card className="py-5">
				<Card.Body>
					<Loader />
				</Card.Body>
			</Card>
		);
	}
	return (
		<AvForm onSubmit={onSubmit}>
			{formData?.map((data, index) => {
				return (
					<Card className="p-4" key={index}>
						<Row>
							<Col
								md={12}
								className="d-flex justify-content-between cursor-pointer mb-3">
								<h4>{Translate[lang].banner}</h4>
								{index > 0 && (
									<i
										className="la la-times text-danger"
										onClick={() => {
											if (data?.id) {
												removeBanner(data?.id);
											} else {
												setFormData((prev) =>
													prev?.filter((_, ind) => index !== ind)
												);
											}
										}}
										style={{ fontSize: "24px" }}
									/>
								)}
							</Col>
							<Col md={6} className="mb-3">
								<div className="image-placeholder">
									<div className="avatar-edit">
										<input
											type="file"
											onChange={(e) => {
												if (!isExist("update_banner")) {
													toast.error("Not Allowed, Don`t have Permission");
													return;
												}
												fileHandler(e, index);
											}}
											id={`imageUpload${index}`}
										/>
										<label htmlFor={`imageUpload${index}`} name=""></label>
									</div>
									<button
										className="delete"
										type="button"
										onClick={() => {
											setFormData((prev) =>
												prev?.map((item, ind) =>
													ind === index
														? {
																...item,
																src: "",
														  }
														: item
												)
											);
										}}>
										<i className="la la-trash text-danger"></i>
									</button>
									<div className="avatar-preview">
										<div id={`imagePreview${index}`}>
											{!!data?.src && !data.loading && (
												<img
													id={`saveImageFile${index}`}
													src={data?.src}
													alt="icon"
												/>
											)}
											{!data?.src && !data.loading && (
												<img
													id={`saveImageFile${index}`}
													src={uploadImg}
													alt="icon"
													style={{
														width: "80px",
														height: "80px",
													}}
												/>
											)}
											{data.loading && <Loader />}
										</div>
									</div>
								</div>
								<span style={{ fontSize: "14px" }}>625*430</span>
							</Col>
							<Col md={6} className="pt-5">
								<AvField
									type="text"
									label={Translate[lang].english_title}
									placeholder={Translate[lang].english_title}
									name={`english_title${index}`}
									value={data?.title_en}
									required
									onChange={(e) =>
										setFormData((prev) =>
											prev?.map((res, ind) =>
												index === ind
													? { ...res, title_en: e.target.value }
													: res
											)
										)
									}
								/>
								<AvField
									type="text"
									label={Translate[lang].arabic_title}
									placeholder={Translate[lang].arabic_title}
									name={`arabic_title${index}`}
									value={data?.title_ar}
									required
									onChange={(e) =>
										setFormData((prev) =>
											prev?.map((res, ind) =>
												index === ind
													? { ...res, title_ar: e.target.value }
													: res
											)
										)
									}
								/>
								<AvField
									type="textarea"
									label={Translate[lang].english_description}
									placeholder={Translate[lang].english_description}
									name={`english_description${index}`}
									value={data?.description_en}
									required
									onChange={(e) =>
										setFormData((prev) =>
											prev?.map((res, ind) =>
												index === ind
													? { ...res, description_en: e.target.value }
													: res
											)
										)
									}
								/>

								<AvField
									type="textarea"
									label={Translate[lang].arabic_description}
									placeholder={Translate[lang].arabic_description}
									name={`arabic_description${index}`}
									value={data?.description_ar}
									required
									onChange={(e) =>
										setFormData((prev) =>
											prev?.map((res, ind) =>
												index === ind
													? { ...res, description_ar: e.target.value }
													: res
											)
										)
									}
								/>
							</Col>
						</Row>
					</Card>
				);
			})}
			{isExist("add_banner") && (
				<div className="d-flex justify-content-between mb-4">
					<Button
						variant="outline-primary"
						className="px-5"
						type="button"
						onClick={() =>
							setFormData((prev) => [
								...prev,
								{
									src: "",
									loading: false,
									title_en: "",
									title_ar: "",
									description_en: "",
									description_ar: "",
								},
							])
						}
						disabled={submitLoading}>
						{Translate[lang].add_new_value}
					</Button>
					<Button
						variant="primary"
						className="px-5"
						type="submit"
						disabled={submitLoading}>
						{Translate[lang].submit}
					</Button>
				</div>
			)}
		</AvForm>
	);
};
export default Banners;
